import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import LoadingData from "components/Loading/LoadingData";
import PerfectScrollbar from "react-perfect-scrollbar";
import NoImageImg from "assets/img/noImage.png";

export default function ChooseProductDialog({
  open,
  onClose,
  productsList,
  setSelectedProduct,
  totalPages,
  setPage,
  searching,
}) {
  const handleOnClick = (product) => {
    setSelectedProduct(product);
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      maxWidth={"xl"}
    >
      <PerfectScrollbar>
        <DialogTitle>
          <Typography variant="h3" component="h3">
            Escolha o Produto para Vincular a Solicitação
          </Typography>
        </DialogTitle>
        <DialogContent>
          {searching ? <LoadingData searching /> : (
            productsList.map((product, index) => {
              const isLast = productsList.length - 1 === index;
              return (
                <Grid
                  container
                  style={{
                    margin: 0,
                    padding: "0 15px",
                    borderBottom: isLast ? "none" : "1px solid #e0e0e0",
                    justifyContent: "space-between",
                  }}
                  alignContent="center"
                  xs={12}
                  key={product.id}
                >
                  <Grid container direction="row" xs={10}>
                    <Grid container xs={2} alignContent="center">
                      <img
                        src={
                          product.Foto || NoImageImg
                        }
                        alt={product.Codigo}
                        style={{
                          height: "100px",
                          minHeight: "100px",
                          width: "100px",
                          objectFit: "cover",
                        }}
                      />
                    </Grid>
                    <Grid
                      container
                      direction="column"
                      xs={10}
                      justify="center"
                      style={{ paddingLeft: "20px" }}
                    >
                      <Typography variant="h4" component="h5">
                        {product.Nome}
                      </Typography>
                      <Typography
                        variant="h5"
                        component="p"
                        style={{ margin: 0 }}
                      >
                        Código: {product.Codigo}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container xs={2} justify="center" alignItems="center">
                    <Button
                      variant="outlined"
                      onClick={() => handleOnClick(product)}
                    >
                      Selecionar
                    </Button>
                  </Grid>
                </Grid>
              );
            })
          )}
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Pagination
            count={totalPages}
            color="primary"
            variant="outlined"
            onChange={(e, page) => {
              setPage(page);
            }}
          />
        </DialogActions>
      </PerfectScrollbar>
    </Dialog>
  );
}
